const { hostname } = window.location;
const currentTenantName = hostname.split('.')[0];

const canUseEnvTenant =
  // Staging and production tenants shouldn't use the env variable
  // (only preview branches)
  !hostname.endsWith('.usestoryteller.com') &&
  // Localhost should only use the env variable if no tenant is specified (ie on localhost:3000)
  (!hostname.endsWith('localhost') || currentTenantName === 'localhost');

export default canUseEnvTenant;
